//modificar fondo final de tokens del fondo¿? para esta semana (sea lo que sea)

import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';

import { modifyVariacionTokens } from '../../actions/cierre_semanal_actions';

import TextField from '@material-ui/core/TextField';
import { Paper, Typography } from '@material-ui/core';
import grey from '@material-ui/core/colors/grey';

import IntNumberFormatInput from '../../components/int_number_input_formatter';

const styles = theme => ({
    root: {
        margin: '8px 0',
        width: '35%'
    },
    paperConcepto: {
        padding: 0,
        margin: 8,
        borderBottom: '3px solid #b8b8b8',
        borderRight: '3px solid #b8b8b8',
        borderRadius: '0px',
    },
    titleIngresos: {
        fontSize: '15px',
        fontWeight: '500',
        color: 'white',
        backgroundColor: grey[600],
        padding: '4px 2px 4px 12px',
    },
    paperItem: {
        margin: '0 auto',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '8px 25px',
        boxShadow: 'none',
    },
    containeritems: {
        width: '100%',
        margin: '8px auto',
    },
    label: {
        maxWidth: '50%',
        fontSize: 13
    },
    inputImporte: {
        textAlign: 'right',
        margin: 8,
        padding: 0,
        fontSize: 11,
        height: 19
    },
    input: {
        width: 75,
        height: 35,
        [`& fieldset`]: {
            borderRadius: 0,
            borderColor: 'black !important',
        },
    },
    // editableInput: {
    //     minWidth: 65,
    //     width: '35%',
    //     height: 35,
    //     [`& fieldset`]: {
    //         borderRadius: 0,
    //         borderColor: '#8dbb35 !important',
    //     },
    // },
});

class CierreSemanalTokensFondo extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            fondoInicial: this.props.datosCierreSemanal.fondoTokensIni,
            fondoFinal: this.props.datosCierreSemanal.fondoTokensEnd,
            variacion: this.props.datosCierreSemanal.fondoTokensEnd - this.props.datosCierreSemanal.fondoTokensIni,
            lastCentroDia: this.props.centroDiaSelected.centro.id + '_' + this.props.centroDiaSelected.dia
        };

    };

    static getDerivedStateFromProps(nextProps, prevState) {

        if (prevState.lastCentroDia !== nextProps.centroDiaSelected.centro.id + '_' + nextProps.centroDiaSelected.dia) {
            return {
                fondoInicial: nextProps.datosCierreSemanal.fondoTokensIni,
                fondoFinal: nextProps.datosCierreSemanal.fondoTokensEnd,
                variacion: nextProps.datosCierreSemanal.fondoTokensEnd - nextProps.datosCierreSemanal.fondoTokensIni,
                lastCentroDia: nextProps.centroDiaSelected.centro.id + '_' + nextProps.centroDiaSelected.dia
            };
        }
        else {
            return null;
        };

    };

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.state.fondoFinal !== this.props.datosCierreSemanal.fondoTokensEnd) {
            this.setState({ ...this.state, fondoFinal: this.props.datosCierreSemanal.fondoTokensEnd, variacion: this.props.datosCierreSemanal.fondoTokensEnd - this.props.datosCierreSemanal.fondoTokensIni });
        };
    };

    renderItem = (label, value) => {
        const { classes } = this.props;
        return [
            <form key={label + '-label'}>
                <Paper className={classes.paperItem} >

                    <Typography variant="subtitle2" className={classes.label}>
                        {label}
                    </Typography>

                    <TextField
                        id={label}
                        key={label + '-value'}
                        value={value}
                        className={classes.input}
                        InputProps={{
                            classes: { input: classes.inputImporte },
                            inputComponent: IntNumberFormatInput
                        }}
                        disabled
                        variant="outlined"
                    />
                </Paper>
            </form>
        ]
    };

    handleVariacionChange = event => {
        this.setState({
            ...this.state,
            variacion: event.target.value,
            fondoFinal: parseFloat(this.state.fondoInicial) + parseFloat((event.target.value).replace(",", ''))
        });
    };

    onValueChange = value => {
        this.props.modifyVariacionTokens(this.state.fondoFinal);
    };

    renderVariacion = () => {
        const { classes } = this.props;
        return [
            <form key={'variacion-label'} >
                <Paper className={classes.paperItem} >

                    <Typography variant="subtitle2" className={classes.label}>
                        Variación Fondo
                    </Typography>

                    <TextField
                        id={"variacion"}
                        key={'variacion-value'}
                        value={this.state.variacion}
                        className={classes.input}
                        InputProps={{
                            classes: { input: classes.inputImporte },
                            inputComponent: IntNumberFormatInput
                        }}
                        variant="outlined"
                        onChange={(event) => this.handleVariacionChange(event)}
                        onBlur={(event) => this.onValueChange(event.target.value)}
                        onKeyPress={(e) => {
                            if (e.key === 'Enter') { e.preventDefault(); this.onValueChange(e.target.value) };
                        }}
                        disabled  //no canviar!
                    />
                </Paper>
            </form>
        ]
    };

    render() {
        const { classes } = this.props;

        if (!this.props.datosCierreSemanal.cajaIDgeneral === undefined || !this.props.datosCierreSemanal.tieneTokens) {
            return (<div></div>);
        };

        return (
            <div className={classes.root}>
                <Paper className={classes.paperConcepto} elevation={0}>
                    <Typography variant="subtitle1" className={classes.titleIngresos}>Tokens fondo</Typography>
                    <div className={classes.containeritems}>
                        {this.renderItem("Fondo inicial", this.props.datosCierreSemanal.fondoTokensIni)}
                        {this.renderVariacion()}
                        {this.renderItem("Fondo final", this.state.fondoFinal)}
                        {this.renderItem("Entregados", this.props.datosCierreSemanal.totalEntregado)}
                        {this.renderItem("Recuperados", this.props.datosCierreSemanal.totalTokensMaq)}
                    </div>
                </Paper>
            </div>
        );
    };
};


CierreSemanalTokensFondo.propTypes = {
    //state
    centroDiaSelected: PropTypes.object.isRequired,
    isSemanaCerrada: PropTypes.bool.isRequired,
    datosCierreSemanal: PropTypes.object.isRequired,
    //dispatch
    modifyVariacionTokens: PropTypes.func.isRequired
    //parameters


};

function mapStateToProps(state) {
    return {
        centroDiaSelected: state.centroDiaSelected,
        isSemanaCerrada: state.datosCierreSemanal.semanaCerrada,
        datosCierreSemanal: state.datosCierreSemanal.datos,
        user: state.oidc.user
    };
};

function mapDispathToProps(dispatch) {
    return bindActionCreators({
        modifyVariacionTokens
    }, dispatch);
};


export default connect(
    mapStateToProps,
    mapDispathToProps
)(withStyles(styles, { withTheme: true })(CierreSemanalTokensFondo));